import { render } from "./Invites.vue?vue&type=template&id=5ea2cc5b&scoped=true"
import script from "./Invites.vue?vue&type=script&lang=js"
export * from "./Invites.vue?vue&type=script&lang=js"

import "./custom-invites.scss?vue&type=style&index=0&id=5ea2cc5b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea2cc5b"]])

export default __exports__